/**
 * 左側欄組件
 * 包含偶像列表、收藏/訂閱入口、標籤篩選器、頁尾
 */
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MyIdol from '@/features/home/components/MyIdol';
import Hashtag from '@/features/home/components/Hashtag';
import SidebarFooter from '@/features/home/components/SidebarFooter';

const LeftSidebar = ({
  showMyIdol = true,
  showNavigation = true,  // 收藏、訂閱入口
  showHashtag = false,    // 標籤篩選器：只有首頁(全站 feed)需要，預設關閉
  showFooter = false,
  tagsData,
  tagsRefreshKey,
  currentPage = 'home'  // 'home' | 'collection' | 'subscription' | 'my-worlds'
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {showMyIdol && (
        <div>
          <MyIdol />
        </div>
      )}

      {showNavigation && (
        <>
          {/* 收藏入口 */}
          <div className="d-none d-md-block">
            <div
              className={`collection-filter-item hover-p ${currentPage === 'collection' ? 'active' : ''}`}
              onClick={() => navigate('/collection')}
            >
              <h5 className="mb-3 d-flex align-items-center">
                <FontAwesomeIcon icon={["fas", "heart"]} className="me-2 text-primary" width="20px" />
                <span>{t('my_collection')}</span>
                <FontAwesomeIcon
                  icon={["fas", "angle-right"]}
                  className="ms-2"
                  size="sm"
                />
              </h5>
            </div>
          </div>

          {/* 訂閱入口 */}
          <div className="d-none d-md-block">
            <div
              className={`collection-filter-item hover-p ${currentPage === 'subscription' ? 'active' : ''}`}
              onClick={() => navigate('/subscription')}
            >
              <h5 className="mb-3 d-flex align-items-center">
                <FontAwesomeIcon icon={["fas", "gem"]} className="me-2 text-primary" width="20px" />
                <span>{t('my_subscription')}</span>
                <FontAwesomeIcon
                  icon={["fas", "angle-right"]}
                  className="ms-2"
                  size="sm"
                />
              </h5>
            </div>
          </div>

          {/* 我的世界入口 */}
          <div className="d-none d-md-block">
            <div
              className={`collection-filter-item hover-p ${currentPage === 'my-worlds' ? 'active' : ''}`}
              onClick={() => navigate('/my-worlds')}
            >
              <h5 className="mb-3 d-flex align-items-center">
                <FontAwesomeIcon icon={["fas", "earth-americas"]} className="me-2 text-primary" width="20px" />
                <span>{t('my_world')}</span>
                <FontAwesomeIcon
                  icon={["fas", "angle-right"]}
                  className="ms-2"
                  size="sm"
                />
              </h5>
            </div>
          </div>
        </>
      )}

      {showHashtag && (
        <Hashtag
          variant="desktop"
          tagsData={tagsData}
          refreshKey={tagsRefreshKey}
        />
      )}

      {showFooter && <SidebarFooter />}
    </>
  );
};

LeftSidebar.propTypes = {
  showMyIdol: PropTypes.bool,
  showNavigation: PropTypes.bool,
  showHashtag: PropTypes.bool,
  showFooter: PropTypes.bool,
  tagsData: PropTypes.array,
  tagsRefreshKey: PropTypes.number,
  currentPage: PropTypes.string
};

export default LeftSidebar;
